import React from 'react'
import { modalVisibility, ModalVisibilityProps, openModal } from 'sb-modal'

import SkipAMonthSuccessModalView from './SkipAMonthSuccessModalView/SkipAMonthSuccessModalView'

import useSkipAMonthSuccessModal from './util/useSkipAMonthSuccessModal'


const SkipAMonthSuccessModal: React.FunctionComponent<SkipAMonthSuccessModal.ModalProps & ModalVisibilityProps> = (props) => {
  const { skippedMonthCount, reasons, form, onSubmit, onClose } = useSkipAMonthSuccessModal(props)

  return (
    <SkipAMonthSuccessModalView
      skippedMonthCount={skippedMonthCount}
      reasons={reasons}
      form={form}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  )
}


export const openSkipAMonthSuccessModal = (props: SkipAMonthSuccessModal.ModalProps) => {
  openModal('skipAMonthSuccess', props)
}


export default modalVisibility('skipAMonthSuccess', SkipAMonthSuccessModal)
